import Swal from "sweetalert2";
import { api } from "../../../infra/api";
import { URLS } from "../../../infra/URLS";

export default async function postImportCsv(value: any, onSuccess: () => void) {
  return await api.post(URLS.NOTA_FISCAL_IMPORT_API, value)
  .then((response) => {
    console.log(response);
    
    Swal.fire({
      title: 'CSV Importado',
      text: 'O CSV foi importado com sucesso!',
      icon: 'success',
      position: 'center',
      confirmButtonText: 'OK',
      confirmButtonColor: '#349946',
      allowOutsideClick: false
    }).then(response => {
      if(response.isConfirmed) {
        onSuccess();
      }
    })
  })
  .catch((err) => {
    console.log(err);
    if(err.response.status){
      Swal.fire({
        title: 'Erro ao Importar CSV',
        text: `${err.response.data.message}`,
        icon: 'error',
        position: 'center',
        confirmButtonText: 'OK',
        confirmButtonColor: '#F27474',
        allowOutsideClick: false
      })
      
    }
  });
}
